import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable react/no-unused-state */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { OverlayContext, OverlayType } from "./context";

var Provider = /*#__PURE__*/function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider(props) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props));
    _this.notificationCloseDelay = 2500;

    _this.show = function (type, theme, context) {
      _this.setState({
        type: type,
        theme: theme,
        context: context
      });

      document.body.style.overflow = type !== OverlayType.message ? "hidden" : "";

      if (type === OverlayType.message) {
        setTimeout(_this.hide, _this.notificationCloseDelay);
      }
    };

    _this.hide = function () {
      _this.setState({
        type: null
      });

      document.body.style.overflow = "";
    };

    _this.state = {
      context: null,
      hide: _this.hide,
      show: _this.show,
      theme: null,
      type: null
    };
    return _this;
  }

  _createClass(Provider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$state;

      if (this.props.router.location.pathname !== prevProps.router.location.pathname && ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.type) !== OverlayType.message) {
        this.hide();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(OverlayContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return Provider;
}(React.Component);

function withRouter(Provider) {
  function ComponentWithRouterProp(props) {
    var location = useLocation();
    var navigate = useNavigate();
    return React.createElement(Provider, _extends({}, props, {
      router: {
        location: location,
        navigate: navigate
      }
    }));
  }

  return ComponentWithRouterProp;
}

export default withRouter(Provider);